import { render, staticRenderFns } from "./datatable.vue?vue&type=template&id=3359ba0a&scoped=true"
import script from "./datatable.vue?vue&type=script&lang=js"
export * from "./datatable.vue?vue&type=script&lang=js"
import style0 from "./datatable.vue?vue&type=style&index=0&id=3359ba0a&prod&scoped=true&lang=css"
import style1 from "./datatable.vue?vue&type=style&index=1&id=3359ba0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3359ba0a",
  null
  
)

export default component.exports